import { render, staticRenderFns } from "./dwsTable.vue?vue&type=template&id=a9b6441a&scoped=true&"
import script from "./dwsTable.vue?vue&type=script&lang=js&"
export * from "./dwsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b6441a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9b6441a')) {
      api.createRecord('a9b6441a', component.options)
    } else {
      api.reload('a9b6441a', component.options)
    }
    module.hot.accept("./dwsTable.vue?vue&type=template&id=a9b6441a&scoped=true&", function () {
      api.rerender('a9b6441a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/preview/dwsTable.vue"
export default component.exports